export const roles = {
    viewer: 1,
    administrator: 2
}